
angular.module('common')
    .constant('version', "3.4.12.0");
